export const channels = [
  { value: 'red', name: 'Red de Oficinas' },
  { value: 'tlm', name: 'Telemarketing' },
  { value: 'fuvex', name: 'Centros de Negocio' },
  { value: 'all', name: 'Todos' },
];
